<template lang="pug">
.reservation-schedule-multiple-input-modal
  b-modal(ref="modal" size="lg" no-close-on-backdrop no-close-on-esc @ok="ok" @cancel="cancel")
    .reservation-schedule-multiple-input-modal-header(slot="modal-header" slot-scope="{ cancel }")
      .float-left.title
        span 予約可能日時の一括設定
      .float-right
        button.btn(type="button" @click="onTemplateList")
          span.ml-1.mr-1 一括設定管理
        button(type="button" class="close" @click="cancel()") ×

    .reservation-schedule-multiple-input-modal-body.register-body
      //- text
      .text.mb-4(style="margin:0 20px;")
        div 表示されている月の予約可能日時を一括で設定することが出来ます。
        div 曜日は複数選択することが出来ます。全ての曜日を選択すると毎日になります。
        div 祝日に関係なく一括設定されます。一括設定後に個別で設定し直してください。
        div 一括設定後に登録もしくは更新せずに画面移動をすると、設定情報が反映されません。

      //- select template
      FormInputSelect(v-model="templateId" :options="templateOptions" keyName="登録済み一括設定の選択" name="template" :styles="{ 'max-width': '540px' }")

      //- inputs
      .input-schedules(v-if="templateId == 0")
        //- input week
        .register-row.input-week
          .register-group
            .register-key
              span.key-name 曜日
              span.validation-label 必須
            .register-value
              //- inputはcheckboxだがラジオボタンと同じ見た目にしたいのでcssクラスはラジオボタンのものを使用する
              label.register-radio-label
                input.register-radio-form(v-model="sunday" name="sunday" type="checkbox")
                span.register-radio-text 日曜日
              label.register-radio-label
                input.register-radio-form(v-model="monday" name="monday" type="checkbox")
                span.register-radio-text 月曜日
              label.register-radio-label
                input.register-radio-form(v-model="tuesday" name="tuesday" type="checkbox")
                span.register-radio-text 火曜日
              label.register-radio-label
                input.register-radio-form(v-model="wednesday" name="wednesday" type="checkbox")
                span.register-radio-text 水曜日
              label.register-radio-label
                input.register-radio-form(v-model="thursday" name="thursday" type="checkbox")
                span.register-radio-text 木曜日
              label.register-radio-label
                input.register-radio-form(v-model="friday" name="friday" type="checkbox")
                span.register-radio-text 金曜日
              label.register-radio-label
                input.register-radio-form(v-model="saturday" name="saturday" type="checkbox")
                span.register-radio-text 土曜日
        .register-row
          .register-group
            .error-messages
              div(v-if="errors.has('day-of-week')")
                label.error-message {{ errors.first('day-of-week') }}

        //- input time
        .register-row.input-time(style="flex-wrap: nowrap;")
          .register-group(style="width: auto;")
            .register-key
              span.key-name 開始時間
              span.validation-label 必須
            .register-value
              select#start-hour.register-form.hour(
                name="start-hour"
                v-model="startHour"
                v-validate="{ required: true }"
                data-vv-as="開始時間（時）"
                :class="{ noinput: !startHour }"
              )
                option(v-for="hour in startHourOptions") {{ hour }}
              span 時

              select#start-min.register-form.min(
                name="start-min"
                v-model="startMin"
                v-validate="{ required: true }"
                data-vv-as="開始時間（分）"
                :class="{ noinput: !startMin, disable: startMinDisabled }"
                :disabled="startMinDisabled"
              )
                option(v-for="min in startMinOptions") {{ min }}
              span 分
          .register-group(style="width: auto;")
            .register-key
              span.key-name 終了時間
              span.validation-label 必須
            .register-value
              select#end-hour.register-form.hour(
                name="end-hour"
                v-model="endHour"
                v-validate="{ required: true }"
                data-vv-as="終了時間（時）"
                :class="{ noinput: !endHour, disable: endHourDisabled }"
                :disabled="endHourDisabled"
              )
                option(v-for="hour in endHourOptions") {{ hour }}
              span 時

              select#end-min.register-form.min(
                name="end-min"
                v-model="endMin"
                v-validate="{ required: true }"
                data-vv-as="終了時間（分）"
                :class="{ noinput: !endMin, disable: endMinDisabled }"
                :disabled="endMinDisabled"
              )
                option(v-for="min in endMinOptions") {{ min }}
              span 分
        .register-row
          .register-group
            .error-messages
              div(v-if="errors.has('start-hour')")
                label.error-message {{ errors.first('start-hour') }}
              div(v-if="errors.has('start-min')")
                label.error-message {{ errors.first('start-min') }}
              div(v-if="errors.has('end-hour')")
                label.error-message {{ errors.first('end-hour') }}
              div(v-if="errors.has('end-min')")
                label.error-message {{ errors.first('end-min') }}

    .reservation-schedule-multiple-input-modal-footer(slot="modal-footer" slot-scope="{ cancel }")
      button.btn.modal-ok-btn(type="button" @click="ok") OK
      button.btn.modal-cancel-btn(type="button" @click="cancel") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Inject, Watch, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { ReservationScheduleModel } from "@/pc/containers/reservations/OnlineReservationScheduleTab.vue";
import { ReservationScheduleTemplateGetModel } from "@/commons/services/ReservationScheduleTemplates";
import FormInputSelect from "@/pc/components/forms/FormInputSelect.vue";

/**
 * ### 面会スケジュール一括入力ダイアログ
 */
@Component({
  components: {
    FormInputSelect
  }
})
export default class ReservationScheduleMultipleInputModal extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** スケジュール */
  @Prop({ required: true })
  value!: Array<Array<ReservationScheduleModel>>;

  /** 時間範囲の最小値 */
  @Prop({ required: true })
  minHour!: number;
  /** 時間範囲の最大値 */
  @Prop({ required: true })
  maxHour!: number;
  /** 分単位 */
  @Prop({ required: true })
  minUnit!: number;

  @Prop()
  scheduleTemplates!: Array<ReservationScheduleTemplateGetModel>;

  /** 選択したテンプレート */
  templateId: number = 0;
  /** テンプレート選択肢 */
  templateOptions: Array<{ value: number | string; label: string }> = [];

  /** 開始時間(時)の選択肢 */
  startHourOptions: Array<string> = [];
  /** 開始時間(分)の選択肢 */
  startMinOptions: Array<string> = [];
  /** 終了時間(時)の選択肢 */
  endHourOptions: Array<string> = [];
  /** 終了時間(分)の選択肢 */
  endMinOptions: Array<string> = [];

  /** 日曜 */
  sunday: boolean = false;
  /** 月曜 */
  monday: boolean = false;
  /** 火曜 */
  tuesday: boolean = false;
  /** 水曜 */
  wednesday: boolean = false;
  /** 木曜 */
  thursday: boolean = false;
  /** 金曜 */
  friday: boolean = false;
  /** 土曜 */
  saturday: boolean = false;

  /** 開始時間(時) */
  startHour: string = "";
  /** 開始時間(分) */
  startMin: string = "";
  /** 終了時間(時) */
  endHour: string = "";
  /** 終了時間(分) */
  endMin: string = "";

  /**
   * ### 分単位の値変更を監視する
   *
   * - 親コンポーネントで分単位の情報をDBから取得して値更新する
   * - 更新されたタイミングで開始時間と終了時間の選択肢を作り直す
   */
  @Watch("minUnit")
  public changeMinUnit(): void {
    this.startHourOptions = this.createStartHourOptions();
    this.startMinOptions = this.createStartMinOptions();
    this.endHourOptions = this.createEndHourOptions();
    this.endMinOptions = this.createEndMinOptions();

    return;
  }

  /**
   * ### 開始時間(時)の値更新を監視する
   *
   * - 開始時間(時)を変更したら以降の入力項目を初期化する
   * - 選択肢が変更されている可能性があるので、選択肢も作り直す
   */
  @Watch("startHour")
  public changeStartHour(): void {
    this.startMin = "";
    this.endHour = "";
    this.endMin = "";

    this.startMinOptions = this.createStartMinOptions();
    this.endHourOptions = this.createEndHourOptions();
    this.endMinOptions = this.createEndMinOptions();

    return;
  }

  /**
   * ### 開始時間(分)の値更新を監視する
   *
   * - 開始時間(時)を変更したら以降の入力項目を初期化する
   * - 選択肢が変更されている可能性があるので、選択肢も作り直す
   */
  @Watch("startMin")
  public changeStartMin(): void {
    this.endHour = "";
    this.endMin = "";

    this.endHourOptions = this.updateEndHourOptions();
    this.endMinOptions = this.createEndMinOptions();

    return;
  }

  /**
   * ### 終了時間(時)の値更新を監視する
   *
   * - 終了時間(時)を変更したら以降の入力項目を初期化する
   * - 選択肢が変更されている可能性があるので、選択肢も作り直す
   */
  @Watch("endHour")
  public changeEndHour(): void {
    this.endMin = "";

    this.endMinOptions = this.updateEndMinOptions();

    return;
  }

  /**
   * ### 開始時間(時)の選択肢を作成する
   *
   * - 時間範囲の最小値～(時間範囲の最大値-1)までを選択肢とする
   */
  public createStartHourOptions(): Array<string> {
    let options: Array<string> = [];

    for (let i = this.minHour; i < this.maxHour; i++) {
      options.push(String(i));
    }

    return options;
  }

  /**
   * ### 開始時間(分)の選択肢を作成する
   */
  public createStartMinOptions(): Array<string> {
    return this.createMinOptions(this.minUnit);
  }

  /**
   * ### 分の選択肢を作成する
   *
   * - 分単位に応じて計算で求める
   */
  public createMinOptions(minUnit: number): Array<string> {
    let options: Array<string> = [];

    const unitCount: number = 60 / minUnit;
    for (let i = 0; i < unitCount; i++) {
      const min: number = i * (60 / unitCount);
      options.push(String(min));
    }

    return options;
  }

  /**
   * ### 終了時間(時)の選択肢を作成する
   *
   * - 時間範囲の最小値～時間範囲の最大値までを選択肢とする
   */
  public createEndHourOptions(): Array<string> {
    let options: Array<string> = [];

    for (let i = this.minHour; i <= this.maxHour; i++) {
      options.push(String(i));
    }

    return options;
  }

  /**
   * ### 終了時間(分)の選択肢を作成する
   */
  public createEndMinOptions(): Array<string> {
    return this.createMinOptions(this.minUnit);
  }

  /**
   * ### 終了時間(時)の選択肢を更新する
   *
   * - 開始時間より終了時間の方が未来になる必要があるため、終了時間(時)は開始時間(時)以降にする場合がある
   * - 開始時間(分)が選択できる開始時間(分)の末尾の場合、終了時間(時)は開始時間(時)+1になる
   * - 上記を考慮した上で終了時間(時)の選択肢を作成しなおす
   */
  public updateEndHourOptions(): Array<string> {
    let options: Array<string> = [];
    let newEndHourStartPosition: number = Number(this.startHour);

    for (let i = 0; i < this.startMinOptions.length; i++) {
      if (this.startMinOptions[i] == this.startMin && i == this.startMinOptions.length - 1) {
        newEndHourStartPosition++;
      }
    }

    for (const endHourOption of this.endHourOptions) {
      if (newEndHourStartPosition <= Number(endHourOption)) {
        options.push(endHourOption);
      }
    }

    return options;
  }

  /**
   * ### 終了時間(分)の選択肢を更新する
   *
   * - 終了時間(時)が時間範囲の最大値と同じ場合、終了時間(分)は強制的に0のみとする
   * - 開始時間(時)と終了時間(時)が同じ場合、終了時間(分)は開始時間(分)より未来にする必要がある
   * - 上記以外は通常通り初期値の選択肢を使用する
   */
  public updateEndMinOptions(): Array<string> {
    let options: Array<string> = [];

    if (this.endHour == String(this.maxHour)) {
      return ["0"];
    }

    if (this.startHour == this.endHour) {
      for (const min of this.endMinOptions) {
        if (Number(this.startMin) < Number(min)) {
          options.push(min);
        }
      }
    } else {
      options = this.createEndMinOptions();
    }

    return options;
  }

  /**
   * ### モーダル表示
   */
  public show(): void {
    const modal: any = this.$refs.modal;
    if (modal) {
      this.initialize();
      const templateOptions = this.createTemplateOptions(this.scheduleTemplates);
      this.templateOptions = templateOptions;
      modal.show();
    }

    return;
  }

  /**
   * ### 入力値の初期化
   */
  public initialize(): void {
    this.sunday = false;
    this.monday = false;
    this.tuesday = false;
    this.wednesday = false;
    this.thursday = false;
    this.friday = false;
    this.saturday = false;

    this.startHour = "";
    this.startMin = "";
    this.endHour = "";
    this.endMin = "";

    return;
  }

  public createTemplateOptions(scheduleTemplates: Array<ReservationScheduleTemplateGetModel> | null): Array<{ value: number | string; label: string }> {
    const options: Array<{ value: number | string; label: string }> = [{ value: 0, label: "使用しない" }];
    if (scheduleTemplates) {
      for (const template of scheduleTemplates) {
        options.push({
          value: template.id,
          label: template.name
        });
      }
    }
    return options;
  }

  /**
   * ### 開始時間(分)を入力不可にするかを返す
   */
  get startMinDisabled(): boolean {
    if (this.startHour != "") {
      return false;
    } else {
      return true;
    }
  }

  /**
   * ### 終了時間(時)を入力不可にするかを返す
   */
  get endHourDisabled(): boolean {
    if (this.startHour != "" && this.startMin != "") {
      return false;
    } else {
      return true;
    }
  }

  /**
   * ### 終了時間(分)を入力不可にするかを返す
   */
  get endMinDisabled(): boolean {
    if (this.startHour != "" && this.startMin != "" && this.endHour != "") {
      return false;
    } else {
      return true;
    }
  }

  /**
   * ### OKボタン押下イベント
   */
  public async ok(): Promise<void> {
    // テンプレートを使用しない
    if (this.templateId == 0) {
      // バリデーションでエラーが出なければ後続処理をする
      const dayOfWeekValidationResult: boolean = await this.validateDayOfWeek();
      const validationResult: boolean = await this.$validator.validateAll();

      if (dayOfWeekValidationResult && validationResult) {
        // 1時間に4レコード分の情報を持ち、管理対象の時間は10時間分を持つ
        const newValue: Array<Array<ReservationScheduleModel>> = new Array((24 - 14) * 4);
        // 1次元目の配列は時間を指す
        for (let i = 0; i < this.value.length; i++) {
          newValue[i] = new Array(this.value[i].length);

          // 2次元目の配列は日を指す
          for (let j = 0; j < this.value[i].length; j++) {
            // 開始時間～終了時間の範囲かつ、対象の曜日であれば予約可能として扱う
            const isTargetTime = this.isTargetTime(this.value[i][j], this.startMinOptions, this.startHour, this.startMin, this.endHour, this.endMin);
            const isTargetDayOfWeek = this.isTargetDayOfWeek(this.value[i][j], this.sunday, this.monday, this.tuesday, this.wednesday, this.thursday, this.friday, this.saturday);
            if (isTargetTime && isTargetDayOfWeek) {
              newValue[i][j] = this.value[i][j];
              newValue[i][j].canReservation = true;
            } else {
              newValue[i][j] = this.value[i][j];
            }
          }
        }
        this.$emit("input", newValue);

        // 親コンポーネントに更新した値を渡したらモーダルを非表示にする
        const modal: any = this.$refs["modal"];
        modal.hide();
      }
    }
    // テンプレートを使用する
    else {
      const template: ReservationScheduleTemplateGetModel = this._getSelectedTemplate as ReservationScheduleTemplateGetModel;
      // 1時間に4レコード分の情報を持ち、管理対象の時間は10時間分を持つ
      const newValue: Array<Array<ReservationScheduleModel>> = new Array((24 - 14) * 4);
      // 1次元目の配列は時間を指す
      for (let i = 0; i < this.value.length; i++) {
        newValue[i] = new Array(this.value[i].length);

        // 2次元目の配列は日を指す
        for (let j = 0; j < this.value[i].length; j++) {
          for (const week of template.weeks) {
            // 開始時間～終了時間の範囲かつ、対象の曜日であれば予約可能として扱う
            const isTargetTime = this.isTargetTime(this.value[i][j], this.createMinOptions(15), week.startHour, week.startMin, week.endHour, week.endMin);
            const isTargetDayOfWeek = this.isTargetDayOfWeek(this.value[i][j], week.sunday, week.monday, week.tuesday, week.wednesday, week.thursday, week.friday, week.saturday);
            if (isTargetTime && isTargetDayOfWeek) {
              newValue[i][j] = this.value[i][j];
              newValue[i][j].canReservation = true;
            } else {
              newValue[i][j] = this.value[i][j];
            }
          }
        }
      }
      this.$emit("input", newValue);

      // 親コンポーネントに更新した値を渡したらモーダルを非表示にする
      const modal: any = this.$refs["modal"];
      modal.hide();
    }

    return;
  }

  get _getSelectedTemplate(): ReservationScheduleTemplateGetModel | null {
    for (const template of this.scheduleTemplates) {
      if (template.id == this.templateId) {
        return template;
      }
    }
    return null;
  }

  public async validateDayOfWeek(): Promise<boolean> {
    this.$validator.errors.remove("day-of-week");

    let valid: boolean = true;
    if (
      this.sunday == false &&
      this.monday == false &&
      this.tuesday == false &&
      this.wednesday == false &&
      this.thursday == false &&
      this.friday == false &&
      this.saturday == false
    ) {
      this.$validator.errors.add({ field: "day-of-week", msg: `曜日は1つ以上選択する必要があります` });
      valid = false;
    }

    return valid;
  }

  /**
   * ### 開始時間～終了時間の範囲かを返す
   */
  public isTargetTime(schedule: ReservationScheduleModel, startMinOptions: string[], startHour: string, startMin: string, endHour: string, endMin: string): boolean {
    let isTargetTime = false;

    // 選択肢(分)は設定値の時間単位で絞りこまれているが、データ自体は0、15、30、45を持っているため、フィルタリングする
    const minUnitMap: Map<number, number> = new Map<number, number>();
    for (const min of startMinOptions) {
      minUnitMap.set(Number(min), Number(min));
    }
    const min: number | undefined = minUnitMap.get(schedule.min);
    if (min == undefined) {
      return false;
    }

    // 開始日時、終了日時、スケジュールの日時を比較して範囲内であれば予約可能として扱う
    const month: number = schedule.month - 1;
    const startDate: Date = new Date(schedule.year, month, schedule.date, Number(startHour), Number(startMin), 0);
    const endDate: Date = new Date(schedule.year, month, schedule.date, Number(endHour), Number(endMin), 0);
    const date: Date = new Date(schedule.year, month, schedule.date, schedule.hour, schedule.min, 0);

    if (startDate.getTime() <= date.getTime() && date.getTime() < endDate.getTime()) {
      isTargetTime = true;
    }

    /** debug console log
    // 〇がつくものをログ出力
    if (isTargetTime) {
      console.debug("startHour: ", Number(this.startHour), "startMin: ", Number(this.startMin), "endHour: ", Number(this.endHour), "endMin: ", Number(this.endMin))
      console.debug("hour: ", schedule.hour, ", min:", schedule.min);
      console.debug("isTargetTime: ", isTargetTime);
      console.debug("---------------------------------------------------------------------------")
    }
    // 〇がつかないものをログ出力
    else {
      console.debug("startHour: ", Number(this.startHour), "startMin: ", Number(this.startMin), "endHour: ", Number(this.endHour), "endMin: ", Number(this.endMin))
      console.debug("hour: ", schedule.hour, ", min:", schedule.min);
      console.debug("isTargetTime: ", isTargetTime);
      console.debug("---------------------------------------------------------------------------")
    }
    */

    return isTargetTime;
  }

  /**
   * ### 対象の曜日あるかを返す
   */
  public isTargetDayOfWeek(
    schedule: ReservationScheduleModel,
    sunday: boolean,
    monday: boolean,
    tuesday: boolean,
    wednesday: boolean,
    thursday: boolean,
    friday: boolean,
    saturday: boolean
  ): boolean {
    const month: number = schedule.month - 1;
    const date: Date = new Date(schedule.year, month, schedule.date, schedule.hour, schedule.min, 0);

    // 日曜日が選択されていて、曜日も同じ
    if (sunday == true && date.getDay() == 0) {
      return true;
    }
    // 月曜日が選択されていて、曜日も同じ
    else if (monday == true && date.getDay() == 1) {
      return true;
    }
    // 火曜日が選択されていて、曜日も同じ
    else if (tuesday == true && date.getDay() == 2) {
      return true;
    }
    // 水曜日が選択されていて、曜日も同じ
    else if (wednesday == true && date.getDay() == 3) {
      return true;
    }
    // 木曜日が選択されていて、曜日も同じ
    else if (thursday == true && date.getDay() == 4) {
      return true;
    }
    // 金曜日が選択されていて、曜日も同じ
    else if (friday == true && date.getDay() == 5) {
      return true;
    }
    // 土曜日が選択されていて、曜日も同じ
    else if (saturday == true && date.getDay() == 6) {
      return true;
    }
    // 曜日が選択されていない、または対象の曜日ではない場合は対象外として扱う
    else {
      return false;
    }
  }

  public cancel(): void {
    this.$emit("cancel");
    return;
  }

  public onTemplateList(): void {
    this.$emit("onTemplateList");
    return;
  }
}
</script>
